<button class="_icon-checkbox _icon-checkbox--{{ theme }}" [ngClass]="{'selected': data.selected, 'not-selectable': !selectable}" *ngIf="data" (click)="toggleState()" [tabIndex]="selectable ? 0 : -1">
  <div tabindex="0" class="_icon-checkbox__hint" *ngIf="data.hint.length" brtTooltip [theme]="selectable ? '' : 'light'" [text]="data.hint"><brt-icon [icon]="'circle-faq'"></brt-icon></div>

  <div class="_icon-checkbox__icon"><span class="icon" [class]="data.icon"></span></div>
  <div class="_icon-checkbox__title">{{data.title}}</div>
</button>
